<template>
  <div>
    <MObject v-if="isObject(part) && !Array.isArray(part) && part != null" :sel="sel"  :label="label" :rprefix="rprefix" :prefix="prefix" :part="part" />
    <MArray v-else-if="Array.isArray(part)" :sel="sel"  :label="label" :rprefix="rprefix" :prefix="prefix" :part="part" />
    <MValue v-else class="d-flex" :rprefix="rprefix" :sel="sel" :prefix="prefix" :label="index" :value="part" />
  </div>
</template>

<script>

export default {
  name: 'MItem',
  props: {
    label: String,
    part: {},
    index: {},
    prefix: String,
    rprefix: String,
    sel: Object,
  },
  components: {
    MValue: () => import('./MValue.vue'),
    MObject: () => import('./MObject.vue'),
    MArray: () => import('./MArray.vue'),
  },
  methods: {
    isObject: function(o) { return typeof o == "object" },
  },
}
</script>
<style>
.dm-rounded {
  border-radius: 8px;
  margin: 5px;
  padding: 3px;
}
.dm-flex {
  display: flex;
  flex-wrap: wrap;
}

.dm-arr {
  background-color: #ffeeee;
  border: 1px solid red;
}

.dm-obj {
  background-color: #ccf;
  border: 1px solid blue;
}

.dm-val {
  border: 1px solid grey;
  background-color: white;
  min-width: 1rem;
  text-align: center;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dm-label {
  background-color: #efe;
}

.dm-bgsel {
  background-color: red;
}
.dm-bgpart {
  background-color: #fdd;
}
</style>
